import type { ChatMessage as ChatMessageType } from '../../types/api';
import { format } from '../../utils/dateFormat';

interface ChatMessageProps {
  message: ChatMessageType;
}

export default function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role.toLowerCase() === 'user';
  const isSystem = message.role.toLowerCase() === 'system';

  if (isSystem) {
    return (
      <div className="flex justify-center my-4">
        <div className="px-4 py-2 bg-gray-100 rounded-full text-sm text-gray-500">
          {message.content}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}
      role="listitem"
    >
      <div
        className={`max-w-[85%] sm:max-w-[75%] ${
          isUser
            ? 'bg-wise text-white rounded-2xl rounded-tr-sm'
            : 'bg-gray-100 text-gray-900 rounded-2xl rounded-tl-sm'
        } px-4 py-3 shadow-sm`}
      >
        {/* Image if present */}
        {message.imageUrl && (
          <div className="mb-2">
            <img
              src={message.imageUrl}
              alt="Uploaded image"
              className="max-w-full rounded-lg max-h-64 object-contain"
              loading="lazy"
            />
          </div>
        )}

        {/* Message content */}
        <p className="text-base leading-relaxed whitespace-pre-wrap break-words">
          {message.content}
        </p>

        {/* Timestamp */}
        <p
          className={`text-xs mt-2 ${
            isUser ? 'text-blue-100' : 'text-gray-400'
          }`}
        >
          {format(new Date(message.createdAt), 'h:mm a')}
        </p>
      </div>
    </div>
  );
}
